import { render, staticRenderFns } from "./StandardPayments.vue?vue&type=template&id=b2466088&"
import script from "./StandardPayments.vue?vue&type=script&lang=js&"
export * from "./StandardPayments.vue?vue&type=script&lang=js&"
import style0 from "./StandardPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports